module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/940eaee5fce37aa61ba5e6845c71d766.png";